import { IQuestion } from '@legalosApi/types/IQuestion';

/**
 * Questions bound to these user-value variables are *never* shown in
 * super-expert mode, even though they carry the AUTO process tag (which the
 * dense form otherwise renders so the user can inspect/override the value).
 *
 * They are pure system/branching questions whose answer is always forced by
 * the server (see `customValuesForce` in PersistentStateQuery /
 * PersistentStateByTokenQuery) and must never be edited by the user:
 *
 * - DIETER_SUBSCRIPTION — the booked tariff (Basic | Premium | Ticket | Keine).
 *   Question text varies between LegalOS apps ("Welche Buchung hast du
 *   vorgenommen?", "Was hast du gebucht?", "Ansprache - Unterscheidung
 *   Tarif - ..."), which is why matching happens on the variable, not on text.
 * - COHORT — A/B/C experiment cohort of the reference user.
 * - IS_WHITELABEL — whether the company runs a whitelabel instance.
 *
 * The value is a fallback option label used only if the user value cannot be
 * resolved against the question's options (should not happen as the server
 * always provides a value, but a hidden question must never block completion).
 */
export const SUPER_EXPERT_HIDDEN_VARIABLES: Readonly<Record<string, string>> = {
  DIETER_SUBSCRIPTION: 'Keine',
  COHORT: 'A',
  IS_WHITELABEL: 'Nein',
};

export function isSuperExpertHiddenQuestion(question: Pick<IQuestion, 'tags'> | undefined): boolean {
  const variable = question?.tags?.variable;
  return !!variable && Object.prototype.hasOwnProperty.call(SUPER_EXPERT_HIDDEN_VARIABLES, variable);
}
